import { pick } from 'lodash';

import { Vertical } from '@bolttech/essentials';
import { Quote } from '../interface/quote.interface';

const QuoteFieldsByVertical: Record<Vertical, string[]> = {
  [Vertical.CarInsurance]: [
    'brand',
    'model',
    'manufacturing_year',
    'filters',
    'quoteId',
    'vertical',
  ],
  [Vertical.DeviceProtectionInsurance]: [],
  [Vertical.PersonalAccidentInsurance]: [],
  [Vertical.MotorcycleInsurance]: [],
  [Vertical.CriticalIllnessInsurance]: [],
  [Vertical.TravelInsurance]: [],
  [Vertical.HealthInsurance]: [],
  [Vertical.PropertyInsurance]: [],
  [Vertical.GroupInsurance]: [],
  [Vertical.ECancerLifeInsurance]: [],
  [Vertical.CoronaVirusInsurance]: []
};


export const filterQuoteFieldsByVertical = (
  quote: Quote,
  vertical: Vertical,
): Partial<Quote> => {
  return pick(quote, QuoteFieldsByVertical[vertical]);
};
